import { getServiceURL } from './transportWrapper';
import {
  IEntity,
  IEntityDataCollectionsResponse,
  IEntityDataResponse,
  IEntityDataWithMetrics,
  IEntityUsersResponse
} from './types';

const entityUsersResponseFields = ['id', 'first_name', 'last_name', 'full_name', 'email'].join(',');

export const entityById = async (id: string | number, clientOptions: RequestInit = {}, hostUrl?: string) =>
  getServiceURL(hostUrl || process.env.DELPHIUS_ENTITY_HOST)
    .options(clientOptions, true)
    .url(`/api/v1/entities/${id}?embed=entity_group`)
    .get()
    .json()
    .then((entity: IEntity): IEntity => entity);

export const getEntityByIdWithMetrics = async (
  subdomain: string,
  clientOptions: RequestInit = {}
): Promise<IEntityDataWithMetrics> =>
  getServiceURL(process.env.ENTITY_DATA_API_HOST)
    .options(clientOptions, true)
    .url(`/api/entitydata/v1/entities`)
    .query({ embed: 'metrics:all', size: 1, subdomain })
    .get()
    .json()
    .then((response: IEntityDataResponse) => response.entities[0]);

export const getEntityUsers = async (id: string | number, clientOptions: RequestInit = {}, hostUrl?: string) =>
  getServiceURL(hostUrl || process.env.USERS_SERVICE_HOST)
    .options(clientOptions, true)
    .url('/api/v1/users')
    .query({
      entity_id: id,
      fields: entityUsersResponseFields
    })
    .get()
    .json()
    .then((response: IEntityUsersResponse) => response.users);

export const getEntityDataEntryRequests = async (
  entityId: string | number,
  clientOptions: RequestInit = {},
  hostUrl?: string
) =>
  getServiceURL(hostUrl)
    .options(clientOptions, true)
    .url('/api/dc-manager-service/v1/data-collections')
    .query({
      entityId: entityId
    })
    .get()
    .json()
    .then((response: IEntityDataCollectionsResponse) => response.data);

export const deleteDataEntryRequestById = async (
  dataEntryRequestId: string | number,
  clientOptions: RequestInit = {},
  hostUrl?: string
) =>
  getServiceURL(hostUrl)
    .options(clientOptions, true)
    .url(`/api/dc-manager-service/v1/data-collections/${dataEntryRequestId}`)
    .delete()
    .json()
    .then((response) => response.data);
